<template>
  <div class="tabs" v-on:touchstart.stop v-on:touchmove.stop>
    <template v-for="(item, index) in data">
        <div class="cell" :key="index" @click="tabClick(item)">
            <span>{{ item.englishContent }}</span>
        </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'quickPhrases',
  data() {
    return {
    };
  },
  props: {
    data: {
      type: [Object],
      default: [],
    },
  },
  methods: {
    tabClick(item) {
        this.$emit("sendText", item.englishContent);
    }
  }
};
</script>

<style lang="less" scoped>
.tabs {
  display: inline-flex;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;

}
.tabs::-webkit-scrollbar {

  display: none; /* Chrome Safari */

}

.cell {
  margin-right: 12px;
  // background: #1d1d1d;
  // border-radius: 8px;
  display: inline-flex;
  align-items: center;
  // border: 1px solid #1d1d1d;
  
  & span {
    display: inline-block;
    height: 18px;
    font-size: 13px;
    font-weight: bold;
    color: #ffffff;
    line-height: 18px;
    word-break:keep-all;
    white-space: nowrap;
    font-family: "TradeGothicLT-Bold";
  }
}
</style>